import { Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import ja from 'date-fns/locale/ja';
import { ReactElement } from 'react';

import { Product } from '@app/types/catalog';
import { getConvertTimeToJp, weeks } from '@app/utils/date';
import { formatPrice } from '@app/utils/format';

interface CardPartTitleProps {
  product: Product;
}

export function CardPartTitle({ product }: CardPartTitleProps): ReactElement {
  const timeLabel = [
    product.customFields?.startTime?.substr(0, 5),
    '~',
    getConvertTimeToJp(product.customFields?.endTime || ''),
  ].join('');

  const weekLabel = product.customFields?.repeatWeek
    ?.map((r) => weeks.find((w) => w.value === r)?.label)
    .filter((r) => r)
    .join('・');

  const variantLabel = [
    formatPrice(product.customFields?.calculatedDairyPay),
    `(時給 ${product.customFields?.calculatedHourlyPay?.toLocaleString()}円)`,
    product.variants[0]?.description ? '+💰' : '',
  ].join('');

  return (
    <Stack>
      <Stack direction="row" spacing={1}>
        {product.customFields?.day ? (
          <Typography>
            {format(new Date(product.customFields.day), 'yyyy年MM月dd日(E)', {
              locale: ja,
            })}
          </Typography>
        ) : (
          <Typography mr={1}>{weekLabel}</Typography>
        )}
        <Typography>{timeLabel}</Typography>
      </Stack>
      <Typography>{variantLabel}</Typography>
    </Stack>
  );
}
